'use client';

import { c as _c } from "react/compiler-runtime";
import { tween, tweenEasings } from '@morpho-org/ui-v6/animations';
import { memo, useLayoutEffect, useRef } from 'react';
import HowItWorksEarnGraphics from './HowItWorksEarnGraphics.tsx';
interface HowItWorksEarnAnimationProps {
  animationStep: number;
  base: string;
}

// Percentage position indexed by animationStep
const percentageDestination = [-7, 18, 49];
const HowItWorksEarnAnimation = t0 => {
  const $ = _c(7);
  const {
    animationStep,
    base
  } = t0;
  const svgRef = useRef(null);
  const position = useRef(percentageDestination[0]);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function updatePosition() {
      if (!svgRef.current) {
        return;
      }
      svgRef.current.style.transform = `translate3d(0, ${-position.current}%, 0)`;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const updatePosition = t1;
  let t2;
  let t3;
  if ($[1] !== animationStep) {
    t2 = () => {
      updatePosition();
      tween(position, {
        current: percentageDestination[animationStep] ?? 0
      }, {
        duration: 0.9,
        ease: tweenEasings.aggressiveInOut,
        onUpdate: updatePosition
      });
    };
    t3 = [animationStep];
    $[1] = animationStep;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useLayoutEffect(t2, t3);
  let t4;
  if ($[4] !== animationStep || $[5] !== base) {
    t4 = <div className="p-md relative aspect-[0.7] max-h-full max-w-full overflow-hidden max-xl:p-[10px] max-lg:p-0 max-md:absolute max-md:top-[-5%] max-md:h-full"><HowItWorksEarnGraphics ref={svgRef} base={base} selectedPart={animationStep} backgroundFillColor="var(--popover)" textFillColor="var(--foreground)" pathsFillColor="var(--foreground)" /></div>;
    $[4] = animationStep;
    $[5] = base;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default memo(HowItWorksEarnAnimation);